import { useState } from "react";
import CustomButton from "../../../Components/Buttons/Custom";
import ModalSimple from "../../../Components/ModalSimple";
import ChallengePriceModal from "./ChallengePriceModal";

export default function Buttons({ data }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="w-full flex gap-2.5 items-center justify-end">
        <CustomButton
          text="ویرایش قیمت و تخفیف"
          svg_name="pen"
          svgClassName="stroke-zi-border-light size-3"
          className="w-full max-w-48 !rounded-lg bg-zi-gradient-button-blue text-zi-text-dark hocus:ring-offset-1 hocus:ring-inset hocus:ring-1 hocus:ring-zi-border-light hocus:ring-offset-zi-blue-light"
          textShadow={true}
          svgShadow={true}
          onClick={() => setShowModal(true)}
        />
      </div>

      {showModal && (
        <ModalSimple showModal={showModal} setShowModal={setShowModal}>
          <ChallengePriceModal
            onClose={() => setShowModal(false)}
            initialPrice={data?.cost}
            initialDiscount={data?.discount}
            initialDiscountPercent={data?.discount_percent}
          />
        </ModalSimple>
      )}
    </>
  );
}
